import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Popover,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  ContentCopyRounded,
  DeleteOutlineRounded,
  ShareRounded,
  GraphicEqRounded,
  ControlPointDuplicateRounded,
} from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import { StyledActionMenuPopover } from './index.style';

const ActionMenuPopover = ({ anchorEl, open, onClose, menuActions }) => {
  const { t } = useTranslation();

  const menuConfig = {
    useVoice: {
      icon: <GraphicEqRounded sx={{ fontSize: 20 }} />,
      label: t('voiceUse'),
    },
    copyVoiceCode: {
      icon: <ContentCopyRounded sx={{ fontSize: 20 }} />,
      label: t('copyVoiceCode'),
    },
    deleteVoice: {
      icon: <DeleteOutlineRounded sx={{ fontSize: 20 }} />,
      label: t('deleteVoice'),
    },
    voiceProfilePage: {
      icon: <ShareRounded sx={{ fontSize: 20 }} />,
      label: t('voiceProfilePage'),
    },
    duplicateVoice: {
      icon: <ControlPointDuplicateRounded sx={{ fontSize: 20 }} />,
      label: t('duplicateVoice'),
    },
  };

  const handleMenuItemClick = (e, action) => {
    e.stopPropagation();
    action.onClick(e);
    onClose();
  };

  const handlePopoverClick = (e) => {
    e.stopPropagation();
  };

  const handleClose = (e) => {
    e?.stopPropagation?.();
    onClose();
  };

  return (
    <Popover
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      onClick={handlePopoverClick}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          marginTop: '8px',
          borderRadius: '12px',
          boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
          minWidth: '200px',
        },
        onClick: handlePopoverClick,
      }}
      slotProps={{
        backdrop: {
          onClick: handlePopoverClick,
        },
      }}
    >
      <StyledActionMenuPopover>
        <Box className="menu-container">
          {menuActions.map((action) => {
            const config = menuConfig[action.key];
            if (!config) return null;

            return (
              <MenuItem
                key={action.key}
                onClick={(e) => handleMenuItemClick(e, action)}
                className="menu-item"
              >
                <ListItemIcon
                  sx={{
                    minWidth: '20px !important',
                    color: config.color || COLOR.darkBlue,
                    opacity: 0.8,
                  }}
                >
                  {config.icon}
                </ListItemIcon>
                <ListItemText
                  primary={config.label}
                  primaryTypographyProps={{
                    sx: {
                      fontSize: '14px',
                      fontWeight: 500,
                      color: config.color || COLOR.darkGray,
                    },
                  }}
                />
              </MenuItem>
            );
          })}
        </Box>
      </StyledActionMenuPopover>
    </Popover>
  );
};

export default ActionMenuPopover;
